import script from "./PatientList.vue?vue&type=script&lang=ts&setup=true"
export * from "./PatientList.vue?vue&type=script&lang=ts&setup=true"

import "./PatientList.vue?vue&type=style&index=0&id=b46ea386&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b46ea386"]])

export default __exports__